/**
 * Object refs travel through the graph as `{ id, name, … }` — or as null when a
 * value node such as Get Hitbox found nothing in the loaded scene. Reading `.id`
 * straight off them turns an authoring mistake into a TypeError, so go through here.
 */
export function readObjectRefId(target: unknown): string {
  if (!target || typeof target !== 'object') return '';
  const id = (target as { id?: unknown }).id;
  return typeof id === 'string' ? id : '';
}
